// combatpro/panels/monsters/studio/MonsterStudioFooter.js
//
// Combat PRO - MonsterStudioFooter (Stage 54 shell, Stage 58 persistence wiring).
//
// The .vi-st-actionbar command bar from the master spec (battletracker.html
// 3361-3372). Stage 58 wires the persistence commands - Save / Save As / Duplicate /
// Favourite / Archive / Delete - to the persistence runtime via props. The Archive
// control becomes context-aware: when the active model is archived it offers Restore
// (the legacy unarchive path), otherwise Archive - the minimal faithful way to
// expose both without a redesign. Test In Encounter remains inert; that is a later
// stage. Stage 59 wires Preview Stat Block; Stage 60 wires Export JSON / Import JSON,
// both to the import/export runtime. Stage 62 wires Test In Encounter to the
// encounter bridge via onTest. The Footer owns no state and performs no persistence
// itself; it only routes clicks. No optional chaining. No em dash.

import React from 'react';

function MonsterStudioFooter(props) {
  var p = props || {};
  var busy = !!p.busy;
  var archived = !!p.archived;

  function call(fn) { if (typeof fn === 'function') { fn(); } }

  return (
    <div className="vi-st-actionbar">
      <button type="button" className="vi-st-primary" disabled={busy} onClick={function() { call(p.onSave); }}>💾 Save</button>
      <button type="button" disabled={busy} onClick={function() { call(p.onSaveAs); }}>📋 Save As</button>
      <button type="button" onClick={function() { call(p.onDuplicate); }}>📑 Duplicate</button>
      <button type="button" disabled={busy} onClick={function() { call(p.onFavourite); }}>⭐ Favourite</button>
      {archived
        ? <button type="button" disabled={busy} onClick={function() { call(p.onRestore); }}>📤 Restore</button>
        : <button type="button" disabled={busy} onClick={function() { call(p.onArchive); }}>📦 Archive</button>}
      <button type="button" className="vi-st-danger" disabled={busy} onClick={function() { call(p.onDelete); }}>🗑 Delete</button>
      <button type="button" onClick={function() { call(p.onExport); }}>📤 Export JSON</button>
      <button type="button" onClick={function() { call(p.onImport); }}>📥 Import JSON</button>
      <button type="button" onClick={function() { call(p.onPreview); }}>📄 Preview Stat Block</button>
      <button type="button" className="vi-st-test" onClick={function() { call(p.onTest); }}>⚔ Test In Encounter</button>
    </div>
  );
}

export default MonsterStudioFooter;
